import * as focusTrap from 'focus-trap';

class Modal {
    constructor() {
        this.activeModal = null;
        this.traps = new Map();
    }

    init() {
        this.bindEvents();
    }

    bindEvents() {
        this.html = document.querySelector('html');

        document.addEventListener('click', this.handleClick.bind(this));
        this.createTraps();
    }

    handleClick(event) {
        const element = event.target;

        if (element.classList.contains('modal-close')) {
            this.close();
        }

        if (this.activeModal && !this.activeModal.querySelector('.modal-content').contains(element)) {
            this.close();
        }

        if (Object.prototype.hasOwnProperty.call(element.dataset, 'modalOpen')) {
            event.preventDefault();
            this.open(element);
        }
    }

    open(element) {
        const target = document.querySelector(element.dataset.modalOpen);

        if (target) {
            const trap = this.traps.get(target);
            this.html.classList.add('is-clipped');
            target.classList.add('is-active');
            
            this.activeModal = target;
            trap.activate();
        }
    }

    close() {
        const target = document.querySelector('.modal.is-active');

        if (target) {
            const trap = this.traps.get(target);
            trap.deactivate();
            target.classList.add('is-closing');

            const videoEl = target.querySelector('iframe') || target.querySelector('video');

            setTimeout(() => {
                this.html.classList.remove('is-clipped');
                target.classList.remove('is-active');
                target.classList.remove('is-closing');
                
                if (videoEl.tagName === 'VIDEO') {
                    videoEl.pause();
                } 
                
                if (videoEl.tagName === 'IFRAME') {
                    const oVideoSrc = videoEl.src;
                    videoEl.src = '';
                    videoEl.src = oVideoSrc;
                }
            }, 400);

            this.activeModal = null;
        }
    }

    createTraps() {
        const modals = document.querySelectorAll('.modal');
        if (modals.length > 0) {
            modals.forEach(modal => {
                const trap = focusTrap.createFocusTrap(modal, {escapeDeactivates: false, fallbackFocus: modal.querySelector('.modal-close')});
                this.traps.set(modal, trap);
                
            })
        }
    }
}

export default new Modal();
